import * as R from 'ramda'
import { watch } from 'vue'

import {
  getParticipantIdOppositeTeamSide,
  getParticipantIdTeamSide,
} from '@collector/shared-ui-domain'
import { IncidentId } from '@collector/sportsapi-client-legacy'

import {
  useEventSettings,
  useIncidents,
  useParticipants,
} from '../../composables'
import { IncidentsTeamPossessionConfig } from '../configuration'

export function useOnIncidentChangeTeamPossession<T extends IncidentId>(
  config: IncidentsTeamPossessionConfig<T>['changePossessionIncidents'],
): void {
  // composables
  const { updateEventSettings } = useEventSettings()
  const { userIncidentsUpdate } = useIncidents()
  const { homeParticipant, awayParticipant } = useParticipants()

  // init
  watch(userIncidentsUpdate, (update) => {
    const lastIncident = R.last(update)

    if (!lastIncident) return

    const {
      data: { incident_id, participant_team_id, action },
    } = lastIncident

    const incidentConfig = config?.[incident_id as T]

    if (incidentConfig) {
      const shouldTrigger = incidentConfig.shouldBeTriggered
        ? incidentConfig.shouldBeTriggered(lastIncident)
        : action === 'insert'

      if (!shouldTrigger) return

      const home = homeParticipant.value
      const away = awayParticipant.value
      if (!home || !away) return

      switch (incidentConfig.toTeamPossession) {
        case 'current': {
          updateEventSettings({
            teamSidePossession: getParticipantIdTeamSide(
              participant_team_id,
              home,
              away,
            )!,
          })

          break
        }
        case 'opposite': {
          updateEventSettings({
            teamSidePossession: getParticipantIdOppositeTeamSide(
              participant_team_id,
              home,
              away,
            )!,
          })

          break
        }
      }
    }
  })
}
